import React from 'react';
import { Link } from 'react-router-dom';
import { LandingContainer, Button, Title, Content } from './landing-styles';

const LandingPage = () => {
	return (
		<React.Fragment>
			<LandingContainer>
				<Content>
					<Title>STAYFIT Change Lives</Title>
					<Link to="/home" className="home-link-btn">
						<Button> Start Now </Button>
					</Link>
				</Content>
			</LandingContainer>
		</React.Fragment>
	);
};

export default LandingPage;
